import StickersSection from './StickersSection';

export default StickersSection;
